<template>
  <div>
    <div
      :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3 position-relative`"
    >
      <Loading v-if="loading" />
      <div class="row">
        <div class="col">
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control border-secondary"
              id="formName"
              maxlength="55"
            /><span class="character-counter" v-if="form.name"
              >{{ form.name.length }} / 55</span
            >
            <label for="formName">Nombre</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("name") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <v-select
              v-model="form.folder_structure_id"
              :reduce="(folderStructure) => folderStructure.id"
              class="form-select border-secondary"
              aria-label="Seleccionar Proyecto"
              :options="folderStructureList"
              label="name"
              :clearable="false"
            >
            </v-select>
            <label for="itemParent">Seleccionar Plantilla</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("template") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <textarea
              v-model="form.description"
              class="form-control border-secondary"
              placeholder="Leave a comment here"
              id="formDescription"
              style="height: 100px"
              maxlength="255"
            ></textarea
            ><span class="character-counter" v-if="form.description"
              >{{ form.description.length }} / 255</span
            >
            <label class="label-form-description" for="formDescription"
              >Descripción</label
            >
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("description") }}
            </p>
          </div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="saveData()"
              class="btn btn-primary"
              :disabled="validateData()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loading from "@/components/Loading.vue";
export default {
  name: "project-index",
  emits: ["setBreadcrumb"],
  components: { Loading },
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Proyectos", link: { name: "projects" } }],
      form: { name: null, description: null },
      folderStructureList: [],
      selectedItems: [],
      componentKey: 0,
      loading: false,
    };
  },
  created() {
    this.setData();
    if (this.dataId) {
      this.breadcrumb.push({
        text: "Editar",
        link: { name: "edit-project-form" },
      });
    } else {
      this.breadcrumb.push({
        text: "Crear",
        link: { name: "new-project-form" },
      });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  methods: {
    setData() {
      let app = this;
      if (this.dataId) {
        this.axios
          .get(`projects/${this.dataId}`)
          .then((result) => {
            app.form = result.data.body;
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.axios
        .get(`folder_structures`)
        .then((result) => {
          app.folderStructureList = result.data.body.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      let app = this;
      this.loading = true;
      if (this.dataId) {
        this.axios
          .put(`projects/${this.dataId}`, { project: this.form })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "projects",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            app.loading = false;
            console.log(error);
          });
      } else {
        this.axios
          .post("projects", { project: this.form })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "projects",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            app.loading = false;
            console.log(error);
          });
      }
    },
    validateData() {
      if (
        this.form.name &&
        this.form.folder_structure_id &&
        this.form.description
      )
        return false;
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "template":
          if (!this.form.folder_structure_id)
            return "Debe seleccionar una plantilla";
          break;
        case "description":
          if (!this.form.description) return "Debe ingresar una descripción";
          break;
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
  },
};
</script>
